import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import DigitalMarketingAhmedabad from "../components/blogs/DigitalMarketingAhmedabad";

const DigitalMarketingAgencyAhmedabad = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.search) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Digital Marketing Agency in Ahmedabad | SMS ZOO ZOO </title>
        <meta
          name="description"
          content="SMS ZOO ZOO offers powerful digital marketing agency in Ahmedabad to boost traffic, generate leads, and grow your business online."
        />

        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.smszoozoo.com/digital-marketing-agency-ahmedabad"
        />
      </Helmet>

      <Navbar />
      <DigitalMarketingAhmedabad />
      <Footer />
    </>
  );
};

export default DigitalMarketingAgencyAhmedabad;
